<template>
  <v-app v-if="this.$vuetify.display.mobile">
    <MobileNavbar/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
  <v-app v-else>
    <WebNavbar/>
    <v-main>
      <router-view/>
    </v-main>
    <ContentFooter></ContentFooter>
  </v-app>
</template>

<script>
import MobileNavbar from '@/components/common/MobileNavbar'
import WebNavbar from "@/components/common/WebNavbar";
import ContentFooter from "@/components/common/ContentFooter";

export default {
  name: 'app',
  components: {ContentFooter, WebNavbar, MobileNavbar},
  data() {
    return {}
  },
}
</script>

<style>

</style>
